import BackButton from '../BackButton';
import Banner from '../../../common/components/Banner';
import CkEditorContent from '../../../common/components/CkEditorContent';
import clsx from 'clsx';
import LanguageSelectionForm from '../../../common/components/LanguageSelectionForm';
import React from 'react';
import { appendCdnToImagePath } from '../../../common/utils/appendCdnToImagePath';
import { Box, ClickAwayListener, Grid, Paper, useMediaQuery, useTheme } from '@mui/material';
import { GeneralContentProps } from '../../interfaces/generalContentProps';
import { GeneralContentStyles } from '../../styles/generalContent';
import { StyledButton } from '../../../common/components/Button';
import { visuallyHidden } from '@mui/utils';

/** Component for LAYOUT_03: Jimi*/
const GeneralContentLayout3: React.FC<GeneralContentProps> = (props: GeneralContentProps): React.JSX.Element => {
  const {
    bannerImageEnabled,
    bannerImage,
    backgroundImageEnabled,
    backgroundColor,
    backgroundImage,
    contentContainerBackgroundColor,
    buttonText,
    buttonStyle,
    content,
    isICPEnabled,
    schedulableTaskItem,
  } = props;

  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const backgroundImagePath = backgroundImage ? appendCdnToImagePath(backgroundImage.path) : '';
  const image = bannerImage ? bannerImage.path : '';

  const { classes } = GeneralContentStyles({
    backgroundColor,
    backgroundImage: backgroundImagePath,
    marginTop: bannerImageEnabled ? '-80px' : '5rem',
    contentBgColor: contentContainerBackgroundColor,
    isICPEnabled,
    isLanguageSelectionFormOpen: props.isLanguageSelectionFormOpen,
  });
  const documentTitle = document.title?.split('|')[0];

  return (
    <Grid className={classes.bgColorContainerJimi}>
      {bannerImageEnabled && <Banner data-testid="banner-image" alt="" src={image} />}
      <Grid
        container
        aria-label={backgroundImage && backgroundImage.name ? backgroundImage.name : backgroundColor}
        className={clsx({
          [classes.bgImageJimi]: backgroundImageEnabled,
          [classes.minGridHeight]: !bannerImage || !content,
          [classes.minCardHeight]: bannerImage,
        })}>
        <span style={visuallyHidden}>{`Background Color ${backgroundColor}`}</span>

        <Grid container justifyContent="center" className={classes.container}>
          <Grid item xs={12} className={classes.cardBottom}>
            <Paper
              role="region"
              aria-label={documentTitle}
              elevation={lgUp ? 1 : 0}
              data-testid="background-jimi"
              className={`
                ${classes.floatingCard}
                ${classes.bgColorCard}
                ${classes.containerJimiFrank}`}>
              {/** Content Container */}
              <CkEditorContent
                content={content}
                pageStartTime={props.pageStartTime}
                generalContentName={props.name}
                taskName={props.taskName}
              />

              {/** Button */}
              <Box width="100%" textAlign="center" className={classes.gridButton}>
                <StyledButton
                  buttonText={buttonText}
                  buttonStyle={buttonStyle}
                  disabled={props.loading || props.isNextButtonDisabled}
                  onClickHandler={props.saveNGetNextWfItem}
                />
                {props.isLanguageSelectionFormOpen && !schedulableTaskItem && (
                  <ClickAwayListener onClickAway={props.handleClickAwayLanguageSelection}>
                    <Box className={classes.languageSelectionOverlay}>
                      <Box textAlign="left" className={classes.languageSelectionModal}>
                        <LanguageSelectionForm languages={props.languages} onLanguageSubmit={props.onLanguageSubmit} />
                      </Box>
                    </Box>
                  </ClickAwayListener>
                )}
                {props.returnToTaskList && <BackButton />}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default GeneralContentLayout3;
